module.exports = __webpack_public_path__ + "static/img/14010208.7db63c62.png";